import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  duplicateData: "",
  duplicateRoom: "",
};

export const duplicateHotelReducer = createSlice({
  name: "duplicateHotel",
  initialState,
  reducers: {
    setDuplicateHotel: (state, action) => {
      state.duplicateData = action.payload;
    },
    setDuplicateRoom: (state, action) => {
      state.duplicateRoom = action.payload;
    },
  },
});
export const { setDuplicateHotel, setDuplicateRoom } =
  duplicateHotelReducer.actions;
export default duplicateHotelReducer.reducer;
